import path from 'path-browserify';

import { getBaseUrl } from '@api/base-url';

const base = ({
  userId = null,
}: {
  userId?: number | null | 'new',
}): string => path.join(
  getBaseUrl({ version: 1 }),
  'users/',
  userId ? `${userId}/` : '',
);

const urls = Object.freeze({
  newUser: (): string => path.join(
    base({ userId: 'new' }),
    '',
  ),
});

export default urls;
